import styles from "./CostDashboardReport.module.css";

const CostDashboardReport = ({ data }) => {
    if (!data) {
        return null;
    }

    const {
        totalCost,
        costPer100Km,
        currency,
        items = [],
    } = data;

    const getUnitLabel = (key) => {
        if (key === "total") {
            return "تومان / کیلومتر";
        }

        return "تومان / کیلومتر";
    };

    return (
        <section
            className={styles.card}
            dir="rtl"
        >
            <div className={styles.header}>
                <div>
                    <span className={styles.eyebrow}>
                        شاخص هزینه
                    </span>

                    <h2>
                        هزینه به مسافت
                    </h2>
                </div>

                <span className={styles.badge}>
                    هزینه
                </span>
            </div>

            {/* <div className={styles.mainMetric}>
                <span>
                    هزینه کل
                </span>

                <strong>
                    {Number(totalCost || 0).toLocaleString("fa-IR")}
                </strong>

                <small>
                    {currency}
                </small>
            </div> */}

            <div className={styles.distanceMetric}>
                <span>
                    هزینه در ۱۰۰ کیلومتر
                </span>

                <strong>
                    {Number(costPer100Km || 0).toLocaleString("fa-IR")}
                </strong>

                <small>
                    {currency} / ۱۰۰ کیلومتر
                </small>
            </div>

            <div className={styles.breakdown}>
                <div className={styles.breakdownHeader}>
                    <span>
                        جزئیات هزینه
                    </span>

                    <span>
                        هزینه / کیلومتر
                    </span>
                </div>

                {items.map((item) => (
                    <div
                        key={item.key}
                        className={
                            item.key === "total"
                                ? styles.totalRow
                                : styles.row
                        }
                    >
                        <span>
                            {item.label}
                        </span>

                        <strong>
                            {Number(
                                item.costPerKm || 0
                            ).toLocaleString("fa-IR")}

                            <small>
                                {getUnitLabel(item.key)}
                            </small>
                        </strong>
                    </div>
                ))}
            </div>
        </section>
    );
};

export default CostDashboardReport;